/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function t(t, h, i, e, d, l, n, o) {
  var u;
  t.ignorePadding && (e = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  }), null != t.width && null != t.height ? u = [t.width, t.height] : null == t.width && null != t.height ? u = [t.height, t.height] : null != t.width && null == t.height ? u = [t.width, t.width] : null == t.width && null == t.height && (u = null);
  var r = i[0] - (e.left + e.right),
      a = i[1] - (e.top + e.bottom);
  var g,
      w,
      c = t.area || {
    x: 0,
    y: 0,
    width: r,
    height: a
  };

  if (u) {
    var _t = r / a,
        _h = u[0] / u[1];

    if (_h > _t) {
      var _t2 = c.width / _h;

      c = {
        x: c.x,
        y: Math.round(c.y + (c.height - _t2) / 2),
        width: c.width,
        height: Math.round(_t2)
      };
    } else {
      var _t3 = c.height * _h;

      c = {
        x: Math.round(c.x + (c.width - _t3) / 2),
        y: c.y,
        width: Math.round(_t3),
        height: c.height
      };
    }
  } else u = [c.width, c.height];

  u[0] > c.width ? (g = Math.min(u[0] / c.width, h), w = u[0] / c.width / g) : (g = 1, w = u[0] / c.width);
  return {
    resolutionScale: g,
    cropArea: {
      x: Math.round((c.x + e.left) * g),
      y: Math.round((c.y + e.top) * g),
      width: Math.round(c.width * g),
      height: Math.round(c.height * g)
    },
    outputScale: w,
    format: d,
    quality: l,
    children: n,
    rotation: o
  };
}

export { t as default };